import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SEND_TYPES } from "app/app-config";

type SendType = `${(typeof SEND_TYPES)[keyof typeof SEND_TYPES]}`;

export const productStyle = {
  [SEND_TYPES.SMS]: {
    icon: "fa-solid fa-comment-sms",
    color: "sms-color",
    bg: "sms-bg",
    tooltip: "SMS",
  },
  [SEND_TYPES.WHATSAPP]: {
    icon: "fa-brands fa-whatsapp",
    color: "whatsapp-color",
    bg: "whatsapp-bg",
    tooltip: "Whatsapp",
  },
  [SEND_TYPES.EMAIL]: {
    icon: "fa-regular fa-envelope",
    color: "email-color",
    bg: "email-bg",
    tooltip: "Email",
  },
  [SEND_TYPES.PUSH]: {
    icon: "fa-regular fa-bell",
    color: "push-color",
    bg: "push-bg",
    tooltip: "Notification Push",
  },
};

@Component({
  selector: "product-icon",
  template: `
    <div *ngIf="style" style="display: inline-block;">
      <div
        [ngClass]="[
          badge ? 'product-badge rounded' : '',
          badge ? style.bg : ''
        ]"
        [ngbTooltip]="style.tooltip"
      >
        <i
          [class]="'product-icon-' + size"
          [ngClass]="[style.color, style.icon]"
        ></i>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductIconComponent {
  @Input() type: SendType;
  @Input() size: "sm" | "md" | "lg" = "md";
  @Input() badge = false;

  get style() {
    return productStyle[this.type];
  }
}
